import { ProblemDetails } from "src/models/ProblemDetails";
import { AudiencePageResponse, ShowV2Response } from "src/models/types";
import { defaultFetch, fetchWithAuth } from "src/utils/auth";

export const readShow = async (publicUrl: string): Promise<ShowV2Response> => {
  if (typeof publicUrl === "undefined" || publicUrl === null) {
    throw new Error("Invalid show URL.")
  }

  const response = await fetchWithAuth(`/api/backend/v2/shows/${publicUrl}`);
  if (response.status === 403) {
    const problemDetails: ProblemDetails = await response.json();
    throw new Error(problemDetails.title, { cause: 403 });
  }
  if (response.status >= 400 && response.status < 600) {
    throw new Error("Oops! It looks like there's a hiccup. Please try again or contact support if the issue persists.");
  }

  const showDetails = await response.json();
  return new ShowV2Response({ data: showDetails });
};

export const readShowByAllocationId = async (allocationId: number): Promise<ShowV2Response> => {
  if (typeof allocationId === "undefined" || allocationId === null) {
    throw new Error("Invalid show URL.")
  }

  const response = await fetchWithAuth(`/api/backend/v2/shows/allocations/${allocationId}`);
  if (response.status === 403) {
    const problemDetails: ProblemDetails = await response.json();
    throw new Error(problemDetails.title, { cause: 403 });
  }

  if (response.status >= 400 && response.status < 600) {
    throw new Error("Oops! It looks like there's a hiccup. Please try again or contact support if the issue persists.");
  }

  const showDetails = await response.json();

  return new ShowV2Response({ data: showDetails });
};

export const readShowsAudience = async (): Promise<AudiencePageResponse> => {
  try {
    const res = await defaultFetch(`/api/backend/v2/shows/audience`)
    if (res.status >= 400 && res.status < 600) {
      console.error("Server not returned a valid response");
      return new AudiencePageResponse({ error: 'Unable to load shows' });
    }
    const resJson = await res.json();
    return new AudiencePageResponse({ data: resJson?.shows });
  } catch (error) {
    let message
    if (error instanceof Error) {
      message = error.message
    } else {
      message = 'Unable to load shows'
    }
    return new AudiencePageResponse({ error: message })
  }
};